import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import store, { RootState } from '../index';
import RolesService from 'services/featureRoles';
import { StatusCode } from 'libs/HTTP/constant';

interface ResourcesStore {
  list: any[];
}
const DefalutData: ResourcesStore = {
  // 资源列表
  list: []
};

const slice = createSlice({
  name: 'resources',
  initialState: DefalutData,
  reducers: {
    setResources: (state, action: PayloadAction<any[]>) => {
      const { payload } = action;
      return { ...state, list: payload };
    }
  }
});
export const resourcesStore = (state: RootState) => state.resources;
export const { setResources } = slice.actions;
export default slice.reducer;

// 获取资源列表
export const getResources = async () => {
  let res: any = await RolesService.getResources();
  if (res.code === StatusCode.success) {
    let list = res.data || [];
    store.dispatch(setResources(list));
  }
  return Promise.resolve(res);
};
